const autoNgTemplateLoaderTemplate1 = require('./sales-income-transactions.template.html');

'use strict';

(function () {
    angular
        .module('app.salesIncomeTransactions', [])
        .config(salesIncomeTransactionsConfig);

    salesIncomeTransactionsConfig.$inject = ['$routeProvider'];

    function salesIncomeTransactionsConfig($routeProvider) {
        $routeProvider
            .when('/sales-income-transactions/from/:from/to/:to', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'SalesIncomeTransactionsController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                }
            })
    }
})();
